import { __assign, __extends, __generator, __spreadArray } from "tslib";
import React, { useRef } from 'react';
import { connect, Provider, createStoreHook, createDispatchHook, createSelectorHook, } from 'react-redux';
import { createStore, applyMiddleware, combineReducers, bindActionCreators, } from 'redux';
import { fork, all } from 'redux-saga/effects';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { reducers as streamReducers, sagas as streamSagas } from '../../Stream';
import { entitiesReducers } from '../../redux/entities';
import sharedConfigReducers from '../../config/reducers';
import publicSessionReducers from '../../publicSession/reducers';
import modalsReducers from '../../Modals/redux/reducer';
import modalsSaga from '../../Modals/redux/saga';
import { initialize as initConfig } from '../../config/actionCreators';
import { getConfig } from '../../config/selectors';
import { getPublicSession } from '../../publicSession/selectors';
import { initialize as initPublicSession } from '../../publicSession/actions';
import { getFlags } from '../../redux/flags/selectors';
import flagsReducers from '../../redux/flags/reducer';
import { setFlags } from '../../redux/flags/actions';
import mediaPopupReducers from '../reducers';
import mediaPopupSaga from '../saga';
var MediaContext = React.createContext(null);
MediaContext.displayName = 'MediaContext';
export var useMMStore = createStoreHook(MediaContext);
export var useMMSelector = createSelectorHook(MediaContext);
export var useMMDispatch = createDispatchHook(MediaContext);
export function useMMDispatchActions(actions) {
    var MMDispatch = useMMDispatch();
    var boundActionsRef = useRef(bindActionCreators(actions, MMDispatch));
    return boundActionsRef.current;
}
export var connectMediaStore = function (mapStateToProps, mapDispatchToProps, mergeProps, options) {
    if (mapStateToProps === void 0) { mapStateToProps = null; }
    if (mapDispatchToProps === void 0) { mapDispatchToProps = null; }
    if (mergeProps === void 0) { mergeProps = null; }
    if (options === void 0) { options = {}; }
    options.context = MediaContext;
    return connect(mapStateToProps, mapDispatchToProps, mergeProps, options);
};
export var reducers = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, sharedConfigReducers), entitiesReducers), streamReducers), publicSessionReducers), mediaPopupReducers), flagsReducers), modalsReducers);
export var sagas = __spreadArray(__spreadArray([mediaPopupSaga], streamSagas), [modalsSaga]);
export function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(sagas.map(fork))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var withOwnReduxStore = function (Component) {
    var enhance = connect(function (state) { return ({
        config: getConfig(state),
        publicSession: getPublicSession(state),
        flags: getFlags(state),
    }); });
    var ComponentWithOwnReduxStore = /** @class */ (function (_super) {
        __extends(ComponentWithOwnReduxStore, _super);
        function ComponentWithOwnReduxStore(props) {
            var _this = _super.call(this, props) || this;
            var config = props.config, flags = props.flags, publicSession = props.publicSession;
            var sagaMiddleware = createSagaMiddleware();
            var composeEnhancers = composeWithDevTools({ name: 'MediaPopup' });
            _this.store = createStore(combineReducers(reducers), composeEnhancers(applyMiddleware(sagaMiddleware)));
            _this.store.dispatch(initConfig(config));
            _this.store.dispatch(initPublicSession({ sessionData: publicSession }));
            _this.store.dispatch(setFlags(flags));
            sagaMiddleware.run(rootSaga);
            return _this;
        }
        ComponentWithOwnReduxStore.prototype.render = function () {
            return (React.createElement(Provider, { context: MediaContext, store: this.store },
                React.createElement(Component, __assign({}, this.props))));
        };
        return ComponentWithOwnReduxStore;
    }(React.Component));
    return enhance(ComponentWithOwnReduxStore);
};
export default withOwnReduxStore;
//# sourceMappingURL=withOwnReduxStore.js.map